import { gql } from "@apollo/client";

const UPDATE_FEATURE_INSTANCE_BY_PK = `
mutation UPDATE_FEATURE_INSTANCE_BY_PK($featureId: uuid!, $set: feature_instance_set_input) {
  update_feature_instance_by_pk(
    pk_columns: {id: $featureId}
    _set: $set
) {
    id
  }
}
`;

const UPDATE_FEATURE_INSTANCE = `mutation UPDATE_FEATURE_INSTANCE($instance_ids: [uuid!]!, $set: feature_instance_set_input = {}) {
  update_feature_instance(where: {id: {_in: $instance_ids}}, _set: $set) {
    affected_rows
  }
}`;

const UPDATE_FEATURE_BID_PACKAGE_BY_PK = `
mutation UPDATE_FEATURE_BID_PACKAGE_BY_PK($featureId: uuid!, $set: feature_bid_package_set_input) {
  update_feature_bid_package_by_pk(
    pk_columns: {feature_instance_id: $featureId}
    _set: $set
  ) {
    feature_instance_id
  }
}
`;

const UPDATE_FEATURE_INSTANCE_SPEC_SECTION = `mutation UPDATE_FEATURE_INSTANCE_SPEC_SECTION($instance_id: uuid!, $objects: [feature_instance_spec_section_insert_input!]!) {
  delete_feature_instance_spec_section(where: {feature_instance_id: {_eq: $instance_id}}) {
    affected_rows
  }
  insert_feature_instance_spec_section(objects: $objects) {
    affected_rows
  }
}
`;

const UPDATE_FEATURE_COMPANY_PARTICIPANT = `mutation UPDATE_COMPANY_PARTICIPANT($instance_id: uuid!, $company_participation_type_id: Int!,$objects: [feature_company_participant_insert_input!]!) {
  delete_feature_company_participant(
    where: {instance_id: {_eq: $instance_id}, company_participation_type_id: {_eq: $company_participation_type_id}}
  ) {
    affected_rows
  }
  insert_feature_company_participant(objects: $objects) {
    affected_rows
  }
}`;

const UPDATE_FEATURE_COMPANY_PARTICIPANT_WITH_EMPTY_USERS = `
mutation UPDATE_FEATURE_COMPANY_PARTICIPANT_WITH_EMPTY_USERS($instance_id: uuid!, $company_participation_type_id: Int!, $user_participation_type_id:Int!,  $objects: [feature_company_participant_insert_input!]!) {
  delete_feature_company_participant(
    where: {instance_id: {_eq: $instance_id}, company_participation_type_id: {_eq: $company_participation_type_id}}
  ) {
    affected_rows
  }
  delete_feature_user_participant(
    where: {_and: [{instance_id: {_eq: $instance_id}}, {user_participation_type_id: {_eq: $user_participation_type_id}}]}
  ) {
    affected_rows
  }
  insert_feature_company_participant(objects: $objects) {
    affected_rows
  }
}
`;

const UPDATE_FEATURE_WORKFLOW_INSTANCE_MILESTONE = `
mutation updateWorkflowMilestone($id: uuid!, $set: feature_workflow_instance_milestones_set_input = {}) {
  update_feature_workflow_instance_milestones_by_pk(
    pk_columns: {id: $id}
    _set: $set
  ) {
    id
  }
}
`;

const MUTATION_CREATE_FEATURE_INSTANCE = `
  mutation CreateFeatureInstancePackage(
    $feature_type: String!
    $feature_instances: [json!]
  ) {
    insert_feature_instances_multi(
      feature_type: $feature_type
      feature_instances: $feature_instances
    ) {
      ids
      message
    }
  }
`;

const MUTATION_UPDATE_FEATURE_USER_PARTICIPANT = `
  mutation updateFeatureUserParticipant(
    $featureInstanceId: uuid!
    $object: feature_user_participant_insert_input!
    $user_participation_type_id: Int!
    $doInsert: Boolean! = true
  ) {
    delete_feature_user_participant(where: {_and: [{instance_id: {_eq: $featureInstanceId}}, {user_participation_type_id: {_eq: $user_participation_type_id}}]}) {
      affected_rows
    }
    insert_feature_user_participant_one(object: $object) @include(if: $doInsert) {
      user_id
    }
}
`;

const UPDATE_BID_PACKAGE_DETAILS_MULTI = `
 mutation UpdateBidPackages($featureInstanceIds: [uuid!]!, $bidPackage: feature_bid_package_input, $workFlowTemplateId: uuid, $participants: [feature_user_participant_input!], $offsetData: feature_offset_data_input) {
    update_bidpackages(featureInstanceIds: $featureInstanceIds, bidPackage: $bidPackage, workFlowTemplateId: $workFlowTemplateId, participants: $participants, offsetData: $offsetData) {
      message
    }
  }
`;

const SAVE_LOCATION_MATERIALS = `
mutation LinkLocationsToFeatures($feature_instance_ids: [uuid], $feature_type: String!, $location_ids: [uuid!]!) {
  link_locations_to_features(feature_instance_ids: $feature_instance_ids, feature_type: $feature_type, location_ids: $location_ids) {
    message
  }
}`;

const UPDATE_FEATURE_SUBMITTALS = `
mutation UPDATE_FEATURE_SUBMITTALS($featureId: uuid!, $set: feature_submittals_set_input) {
  update_feature_submittals(
    where: {feature_instance_id: {_eq: $featureId}}
    _set: $set
  ) {
    affected_rows
  }
}
`;

const UPDATE_FEATURE_MATERIALS = `
mutation UPDATE_FEATURE_MATERIAL_FIELDS_BY_PK($featureId: uuid!, $set: feature_materials_set_input) {
  update_feature_materials(
    where: {feature_instance_id: {_eq: $featureId}}
    _set: $set
  ) {
    affected_rows
  }
}
`;

const UPDATE_FEATURE_MATERIALS_FIELDS_MANY = `mutation UPDATE_FEATURE_MATERIALS_FIELDS_MANY($instance_ids: [uuid!]!, $set: feature_materials_set_input = {}) {
  update_feature_materials_many(
    updates: {where: {feature_instance_id: {_in: $instance_ids}}, _set: $set}
  ) {
    affected_rows
  }
}`;

const UPDATE_FEATURE_SUBMITTAL_FIELDS_MANY = `
mutation UPDATE_FEATURE_SUBMITTAL_FIELDS_MANY($featureIds: [uuid!]!, $set: feature_submittals_set_input) {
  update_feature_submittals(
    where: {feature_instance_id: {_in: $featureIds}}
    _set: $set
  ) {
    affected_rows
  }
}
`;

const UPDATE_FEATURE_SHIPPING_LOCATION = `
  mutation UPDATE_FEATURE_SHIPPING_LOCATION(
    $featureIds: [String!]!
    $placeId: String
  ) {
    update_feature_shipping_location(
      feature_instance_ids: $featureIds
      place_id: $placeId
    ) {
      message
    }
  }`;

const CREATE_DUPLICATE_OF_FEATURE_INSTANCE = `
 mutation CREATE_DUPLICATE_OF_FEATURE_INSTANCE($data: duplicate_feature_instance_input!) {
  duplicate_feature_instance(data: $data) {
    id
    message
  }
}
`;

const UPDATE_FEATURE_INSTANCES = `
mutation UPDATE_FEATURE_INSTANCES($feature_instance_type_id: Int!, $feature_instances: [json!]) {
  update_feature_instances(
  feature_instance_type_id: $feature_instance_type_id
  feature_instances: $feature_instances
 ) {
  message
 }
}`;

const UPDATE_FEATURE_DISTRIBUTION_LIST = gql`
  mutation UPDATE_FEATURE_DISTRIBUTION_LIST(
    $where: feature_distribution_list_bool_exp!
  ) {
    update_feature_distribution_list(_set: { deleted: true }, where: $where) {
      affected_rows
    }
  }
`;

const INSERT_FEATURE_DISTRIBUTION_LIST = gql`
  mutation INSERT_FEATURE_DISTRIBUTION_LIST(
    $data: [feature_distribution_list_insert_input!]!
    $constraint: feature_distribution_list_constraint!
  ) {
    insert_feature_distribution_list(
      objects: $data
      on_conflict: { constraint: $constraint, update_columns: deleted }
    ) {
      affected_rows
    }
  }
`;

const MUTATION_UPDATE_FEATURE_UNREGISTERED_USER_VENDOR_PARTICIPANT = `
  mutation updateFeatureUnregisteredUserVendorParticipant($featureInstanceId: uuid!, $insertUserObject: feature_user_participant_insert_input!, $insertCompanyObjects: [feature_company_participant_insert_input!]!, $user_participation_type_id: Int!, $company_participation_type_id: Int!) {
    delete_feature_user_participant(where: {_and: [{instance_id: {_eq: $featureInstanceId}}, {user_participation_type_id: {_eq: $user_participation_type_id}}]}) {
      affected_rows
    }
    delete_feature_company_participant(
    where: {instance_id: {_eq: $featureInstanceId}, company_participation_type_id: {_eq: $company_participation_type_id}}
    ) {
      affected_rows
    }
    insert_feature_user_participant_one(object: $insertUserObject) {
      user_id
    }
    insert_feature_company_participant(objects: $insertCompanyObjects) {
    affected_rows
  }
}
`;

const MUTATION_BULK_EDIT_FEATURE_INSTANCES = `
mutation BulkEditFeatureInstances($feature_instance_type_id: Int!, $feature_instance_ids: [String!], $updates: json!) {
  bulk_edit_feature_instances(feature_instance_type_id: $feature_instance_type_id, feature_instance_ids: $feature_instance_ids, updates: $updates) {
    message
  }
}
`;

const DELETE_FEATURE_INSTANCE = `mutation DeleteFeatureInstances($feature_instance_ids: [uuid!]!, $feature_type_id: Int!) {
  delete_feature_instances(feature_instance_ids: $feature_instance_ids, feature_type_id: $feature_type_id) {
    message
  }
}`;

export {
  UPDATE_FEATURE_BID_PACKAGE_BY_PK,
  UPDATE_FEATURE_INSTANCE_BY_PK,
  UPDATE_FEATURE_INSTANCE_SPEC_SECTION,
  UPDATE_FEATURE_COMPANY_PARTICIPANT,
  UPDATE_FEATURE_COMPANY_PARTICIPANT_WITH_EMPTY_USERS,
  UPDATE_FEATURE_WORKFLOW_INSTANCE_MILESTONE,
  MUTATION_CREATE_FEATURE_INSTANCE,
  MUTATION_UPDATE_FEATURE_USER_PARTICIPANT,
  UPDATE_BID_PACKAGE_DETAILS_MULTI,
  SAVE_LOCATION_MATERIALS,
  UPDATE_FEATURE_SUBMITTALS,
  UPDATE_FEATURE_MATERIALS,
  UPDATE_FEATURE_MATERIALS_FIELDS_MANY,
  UPDATE_FEATURE_SUBMITTAL_FIELDS_MANY,
  UPDATE_FEATURE_SHIPPING_LOCATION,
  UPDATE_FEATURE_INSTANCE,
  CREATE_DUPLICATE_OF_FEATURE_INSTANCE,
  UPDATE_FEATURE_INSTANCES,
  UPDATE_FEATURE_DISTRIBUTION_LIST,
  INSERT_FEATURE_DISTRIBUTION_LIST,
  MUTATION_UPDATE_FEATURE_UNREGISTERED_USER_VENDOR_PARTICIPANT,
  MUTATION_BULK_EDIT_FEATURE_INSTANCES,
  DELETE_FEATURE_INSTANCE
};
